var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0566406 12.6866C0.0566406 12.8466 0.13664 13.0866 0.21664 13.1666L5.01664 19.1666C5.29664 19.5266 5.81664 19.5666 6.13664 19.2866C6.45664 19.0066 6.53664 18.4866 6.25664 18.1666L2.49664 13.4466H23.2566C23.6966 13.4466 24.0566 13.0866 24.0566 12.6466C24.0566 12.2066 23.6966 11.8466 23.2566 11.8466H2.53664L6.29664 7.12663C6.57664 6.80663 6.49664 6.28663 6.17664 6.00663C5.85664 5.72663 5.29664 5.80663 5.05664 6.12663L0.256641 12.1266C0.0966406 12.3266 0.0566406 12.4466 0.0566406 12.6866Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.470a81f22f0be0e1811a92f0bbfb18ad.svg";
export { ForwardRef as ReactComponent };